"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Метод поиска в строке подстроки не учитывая регистр
 * @param value - строка где ищем
 * @param substring - строка что ищем
 */
function hasSubstring(value, substring) {
    return (value || '').toLowerCase().includes((substring || '').toLowerCase());
}
exports.hasSubstring = hasSubstring;
//# sourceMappingURL=hasSubstring.js.map